import { register } from "swiper/element/bundle";

const utilsSwiper = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    register();
  };
  init();
};

try {
  utilsSwiper();
} catch (error) {
  console.error("utilsSwiper", error);
}
